import { queryOptions, useQuery } from "@tanstack/react-query";

import { mapCarPayloadToCar } from "./utils";

import { api } from "@/lib/api-client";
import { hasAccessToken } from "@/lib/auth";

import type { QueryConfig } from "@/lib/react-query";
import type { Car, CarPayload } from "@/types/car";

export const getCar = async (carId: string) => {
  const response = (await api.get(`/carburate/cars/${carId}/`)) as CarPayload;
  return mapCarPayloadToCar(response) as Car;
};

export const getCarQueryOptions = (carId: string) => {
  return queryOptions({
    queryKey: ["cars", carId],
    queryFn: () => getCar(carId),
  });
};

type UseCarOptions = {
  carId: string;
  enabled?: boolean;
  queryConfig?: QueryConfig<typeof getCar>;
};

export const useCar = ({ carId, enabled = true, queryConfig }: UseCarOptions) => {
  return useQuery({
    enabled: hasAccessToken() && enabled,
    ...getCarQueryOptions(carId),
    ...queryConfig,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });
};
